/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upcoming_CaptionInputs */

const id_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Mendatang`)
};

const ms_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Akan Datang`)
};

const da_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende Tilbud`)
};

const de_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorstehende Angebote`)
};

const en_us2_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming Offers`)
};

const es_es2_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas próximas`)
};

const es_mx2_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas ofertas`)
};

const fil_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Paparating na Offer`)
};

const fr_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres à venir`)
};

const it_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossime offerte`)
};

const hu_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő ajánlatok`)
};

const nl_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankomende aanbiedingen`)
};

const no_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende tilbud`)
};

const pl_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące oferty`)
};

const pt_br2_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const pt_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximas ofertas`)
};

const ro_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte viitoare`)
};

const fi_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulevat tarjoukset`)
};

const sv_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommande erbjudanden`)
};

const vi_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi sắp tới`)
};

const tr_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan Teklifler`)
};

const cs_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadcházející nabídky`)
};

const bg_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящи оферти`)
};

const ru_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящие предложения`)
};

const uk_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майбутні пропозиції`)
};

const ar_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض القادمة`)
};

const hi_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी ऑफ़र`)
};

const th_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอที่กำลังจะมา`)
};

const ja_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今後のオファー`)
};

const zh_cn2_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const zh_hant1_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const ko_components_upcoming_caption = /** @type {(inputs: Components_Upcoming_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

/**
* | output |
* | --- |
* | "Upcoming Offers" |
*
* @param {Components_Upcoming_CaptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_upcoming_caption = /** @type {((inputs?: Components_Upcoming_CaptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upcoming_CaptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_upcoming_caption(inputs)
	if (locale === "ms") return ms_components_upcoming_caption(inputs)
	if (locale === "da") return da_components_upcoming_caption(inputs)
	if (locale === "de") return de_components_upcoming_caption(inputs)
	if (locale === "en-US") return en_us2_components_upcoming_caption(inputs)
	if (locale === "es-ES") return es_es2_components_upcoming_caption(inputs)
	if (locale === "es-MX") return es_mx2_components_upcoming_caption(inputs)
	if (locale === "fil") return fil_components_upcoming_caption(inputs)
	if (locale === "fr") return fr_components_upcoming_caption(inputs)
	if (locale === "it") return it_components_upcoming_caption(inputs)
	if (locale === "hu") return hu_components_upcoming_caption(inputs)
	if (locale === "nl") return nl_components_upcoming_caption(inputs)
	if (locale === "no") return no_components_upcoming_caption(inputs)
	if (locale === "pl") return pl_components_upcoming_caption(inputs)
	if (locale === "pt-BR") return pt_br2_components_upcoming_caption(inputs)
	if (locale === "pt") return pt_components_upcoming_caption(inputs)
	if (locale === "ro") return ro_components_upcoming_caption(inputs)
	if (locale === "fi") return fi_components_upcoming_caption(inputs)
	if (locale === "sv") return sv_components_upcoming_caption(inputs)
	if (locale === "vi") return vi_components_upcoming_caption(inputs)
	if (locale === "tr") return tr_components_upcoming_caption(inputs)
	if (locale === "cs") return cs_components_upcoming_caption(inputs)
	if (locale === "bg") return bg_components_upcoming_caption(inputs)
	if (locale === "ru") return ru_components_upcoming_caption(inputs)
	if (locale === "uk") return uk_components_upcoming_caption(inputs)
	if (locale === "ar") return ar_components_upcoming_caption(inputs)
	if (locale === "hi") return hi_components_upcoming_caption(inputs)
	if (locale === "th") return th_components_upcoming_caption(inputs)
	if (locale === "ja") return ja_components_upcoming_caption(inputs)
	if (locale === "zh-CN") return zh_cn2_components_upcoming_caption(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_upcoming_caption(inputs)
	return ko_components_upcoming_caption(inputs)
});
export { components_upcoming_caption as "components.upcoming.caption" }